import React from 'react'
import Header from '../../../Components/Header/Header'
import Sidebar from '../../../Components/Sidebar/Sidebar'
import { Outlet } from 'react-router-dom' // استيراد Outlet
import "./DashboardLayout.scss"

export default function Layout() {
  return (
    <div className="layout">
      <Header /> 
      <div className="layout__content">
        <Sidebar className="sidebar" /> 
        <div className="layout__outlet">
          <Outlet /> 
        </div>
      </div>
    </div>
  )
}

